import React from 'react';
import { AlertTriangle, BookOpen, Archive } from 'lucide-react';
const columns = [{
  icon: AlertTriangle,
  subhead: 'Identify the Signals',
  body: 'Learn to recognize the mechanisms of social control before they become irreversible.'
}, {
  icon: BookOpen,
  subhead: 'The Dismantling Manual',
  body: 'How an oil powerhouse was left without fuel and its currency turned to dust.'
}, {
  icon: Archive,
  subhead: 'Memory Against Oblivion',
  body: "We leave a record so the world cannot say it didn't know. So it never happens again."
}];
export function WarningSection() {
  return <section className="bg-[#0a0a0a] py-12 sm:py-20 px-6 relative border-t border-gray-900/60" data-id="element-250">
      <div className="max-w-6xl mx-auto" data-id="element-251">
        {/* Header */}
        <div className="text-center mb-16 flex flex-col items-center gap-6" data-id="element-252">
          {/* Red-to-blue-to-gold gradient divider */}
          <div className="h-px w-32" style={{
          background: 'linear-gradient(to right, #DC2626, #2563eb, #d4a85a)'
        }} data-id="element-253" />

          <p className="text-[#d4a85a] uppercase tracking-[0.25em] text-[11px] sm:text-xs font-semibold" data-id="element-254">
            Beyond Venezuela
          </p>

          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#e8e2d4] font-normal leading-tight" data-id="element-255">
            A Warning for the World
          </h2>

          <p className="font-serif text-[#e8e2d4] text-lg sm:text-xl leading-[1.7] font-light max-w-3xl mt-4" data-id="element-256">
            Venezuela wasn't always synonymous with crisis. For decades, it was
            the fulfilled promise of Latin America. This book doesn't just
            record the pain of those who left; it exposes the sequence of
            decisions that can destroy any nation.
          </p>
        </div>

        {/* 3-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-257">
          {columns.map(c => <div key={c.subhead} className="bg-[#111] border border-[#d4a85a]/20 rounded-lg p-8 hover:border-[#d4a85a]/50 transition-colors flex flex-col gap-5 text-left" data-id="element-258">
              <c.icon className="w-7 h-7 text-[#d4a85a]" strokeWidth={1.5} data-id="element-259" />
              <h3 className="text-[#e8e2d4] uppercase tracking-[0.15em] text-sm font-bold" data-id="element-260">
                {c.subhead}
              </h3>
              <p className="text-gray-400 text-[15px] leading-relaxed font-light" data-id="element-261">
                {c.body}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}